module.exports = __webpack_public_path__ + "static/box-c26d8678de550de310202f3fc0f60396.png";